import MapService from 'app/shared/utilities/imagery/map_service';
import WebMapService from 'app/shared/utilities/imagery/web_map_service';
import WebMapTileService from 'app/shared/utilities/imagery/web_map_tile_service';

export default class OpenGisLookupService {
    // Making this non static so we can mock it in testing
    // eslint-disable-next-line class-methods-use-this
    getByURL(url: string): MapService | null {
        if (WebMapTileService.regex.test(url)) {
            return new WebMapTileService(url);
        } else if (WebMapService.regex.test(url)) {
            return new WebMapService(url);
        }

        return null;
    }
}
